
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./LoginApp": () => {
return __webpack_require__.e(/*  | __federation_expose_LoginApp */ "5021").then(() => (() => (__webpack_require__(7350))));
},
"./PolicyApp": () => {
return __webpack_require__.e(/*  | __federation_expose_PolicyApp */ "2904").then(() => (() => (__webpack_require__(7623))));
},
"./ProfileApp": () => {
return __webpack_require__.e(/*  | __federation_expose_ProfileApp */ "8437").then(() => (() => (__webpack_require__(3058))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };